module.exports = __webpack_public_path__ + "science.wet-and-dry.dot.dry.png?525a941fd9a43a0e1d3a4893466e90b7";